import React, { FC } from 'react';

import { Box, Card, CardContent, Typography } from '@mui/material';

import AuthorityProvidedFieldsDataEntry from './AuthorityProvidedFieldsDataEntry';
import WaterAuthoritySelectionDropdown from './WaterAuthoritySelectionDropdown';

import { BackflowJobGroup } from '../../model';

interface WaterAuthorityUpdatingFieldsProps {
  backflowJobGroup: BackflowJobGroup;
  fetchBackflowJobGroup: () => void;
}

const WaterAuthorityUpdatingFields: FC<WaterAuthorityUpdatingFieldsProps> = (props) => {
  const { backflowJobGroup, fetchBackflowJobGroup } = props;

  return (
    <Card elevation={3}>
      <CardContent>
        <Box display="flex" flexDirection="column" gap={2} mb={3}>
          <WaterAuthoritySelectionDropdown
            backflowJobGroup={backflowJobGroup}
            fetchBackflowJobGroup={fetchBackflowJobGroup}
          />
        </Box>
        <Box display="flex" flexDirection="column" gap={2} mb={3}>
          <Typography variant="h6" fontWeight="600">
            Preferred Submission Method
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {backflowJobGroup.submission_method || 'Not set'}
          </Typography>
        </Box>
        <AuthorityProvidedFieldsDataEntry
          backflowJobGroup={backflowJobGroup}
          fetchBackflowJobGroup={fetchBackflowJobGroup}
        />
      </CardContent>
    </Card>
  );
};

export default WaterAuthorityUpdatingFields;
